export function getIndexFromMadladName(name: string): string{
  return name
  .replace("NFT ", "")
  .replace("Mad Lad #", "")
  .replace("Mad Lads #", "")
  .replace("Mad Rug #", "")
  .replace("#", "");
}